import '/assets/styles/sections/web-page-header.scss';
import { useEffect } from 'react';
import classNames from 'classnames';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';
import { useMenu } from '/utilities/menu';
import { useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { getLanguage } from '/data/languages';

const branchRouteKeys = ['webMenu', 'webMenuCategory', 'webMenuProduct'];

const WebPageHeader = ({ title, showBranchName, backLink, className }) => {
	const { openModal } = useModals();
	const { language } = useTranslation();
	const { getMenu, loadMenu } = useMenu();
	const { branchSlug } = useParams(branchRouteKeys);

	const branchName = showBranchName ? getMenu(branchSlug)?.title : null;

	useEffect(() => {
		// Ürün sayfası gibi menüyü kendisi yüklemeyen sayfalar için.
		if (showBranchName && branchSlug) {
			loadMenu(branchSlug).catch(() => {});
		}
	}, [showBranchName, branchSlug, loadMenu]);

	const titleElem = title ? <h1 className="bottom-title">{title}</h1> : <Placeholder className="bottom-title" />;

	return (
		<section className={classNames('section', 'web-menu-header', className)}>
			<div className="header-top">
				<div className="wrapper top-wrap">
					<Img src={image_logo} className="header-logo" />

					<button
						type="button"
						className="header-languagebtn"
						onClick={() => openModal('languages')}
					>
						{getLanguage(language)?.flag} {language.toUpperCase()}
					</button>
				</div>
			</div>
			<div className="header-bottom">
				<div className="wrapper bottom-wrap">
					{backLink ? (
						<Link className="bottom-backlink" {...backLink}>
							<span className="bottom-backbtn">
								<Icon name="angle-left" />
							</span>
							{titleElem}
						</Link>
					) : (
						<>
							{backLink !== false && (
								<span className="bottom-backbtn disabled">
									<Icon name="angle-left" />
								</span>
							)}
							{titleElem}
						</>
					)}
					{branchName && <span className="bottom-subtitle">{branchName}</span>}
				</div>
			</div>
		</section>
	);
};

export default WebPageHeader;
